import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { format } from "date-fns";
import Text from "../../../utils/Custom/text";
import CommonForm from "../../../utils/commonComponent/commonForm";
import { CancelButton, SaveAndUpdate, UploadButton, AddButton } from "../../../utils/Custom/Button";
import { fetchCountOfTable, fetchQuery } from "../../../utils/commonComponent/fetched";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL, employeeUnicode } from "../../../global";
import EditableTable from "../../../utils/commonComponent/editableTable";
import LoaderModal from "../../../utils/loader/loader";
import { getPermissions } from "../rbac/hasAccess";
import DownloadIcon from "@mui/icons-material/Download";
import { generateApplicationFormPDF } from "./applicationFormPDF";
import moment from "moment";
import EmployeeExcelUpload from "./employeeExcelUpload";
import { TextFields, DateInput, AutoCompletes } from "../../../utils/Custom/custominput";
import { validateRequiredFields } from "../../../utils/commonComponent/errorAlert";
import { branchOptions, departmentOptions, designationOptions, HR_employeeStatus, employeeTypeOptions } from "./employeeConstants";
import { statesList } from "../../constants/stateList";

const employeeQualificationInputFields = [
  { type: "Textarea", label: "SSC School Name ", stateKey: "SSCName" },
  { type: "Textarea", label: "SSC Percentage ", stateKey: "SSCPercentage" },
  { type: "Textarea", label: "SSC Passing Year ", stateKey: "SSCPassyear" },
  {
    type: "ImageUpload",
    tooltipLabel: "SSC Marksheet ",
    stateKey: "SSCMarksheetUrl",
    label: "SSC Marksheet ",
    downloadFile: true,
  },
  { type: "Textarea", label: "HSC/Diploma College Name ", stateKey: "HSCName" },
  {
    type: "Textarea",
    label: "HSC/Diploma Percentage ",
    stateKey: "HSCPercentage",
  },
  {
    type: "Textarea",
    label: "HSC/Diploma Passing Year ",
    stateKey: "HSCPassyear",
  },
  {
    type: "ImageUpload",
    tooltipLabel: "HSC/Diploma Marksheet ",
    stateKey: "HSCMarksheetUrl",
    label: "HSC/Diploma Marksheet ",
    downloadFile: true,
  },
  {
    type: "Textarea",
    label: "Graduation College Name ",
    stateKey: "GraduationName",
  },
  {
    type: "Textarea",
    label: "Graduation Percentage ",
    stateKey: "GraduationPercentage",
  },
  {
    type: "Textarea",
    label: "Graduation Passing Year ",
    stateKey: "GraduationPassyear",
  },
  {
    type: "ImageUpload",
    tooltipLabel: "Graduation Marksheet ",
    stateKey: "GraduationMarksheetUrl",
    label: "Graduation Marksheet ",
    downloadFile: true,
  },
  { type: "Textarea", label: "PG College Name", stateKey: "PGName" },
  { type: "Textarea", label: "PG Percentage", stateKey: "PGPercentage" },
  { type: "Textarea", label: "PG Passing Year", stateKey: "PGPassyear" },
  {
    type: "ImageUpload",
    tooltipLabel: "PG Marksheet",
    stateKey: "PGMarksheetUrl",
    label: "PG Marksheet",
    downloadFile: true,
  },
  { type: "Textarea", label: "PhD College Name", stateKey: "PhDName" },
  { type: "Textarea", label: "PhD Percentage", stateKey: "PhDPercentage" },
  { type: "Textarea", label: "PhD Passing Year", stateKey: "PhDPassyear" },
  {
    type: "ImageUpload",
    tooltipLabel: "PhD Marksheet ",
    stateKey: "PhDMarksheetUrl",
    label: "PhD Marksheet ",
    // downloadFile: true,
  },
];

const additionalQualificationInputFields = [
  { type: "Textarea", label: "Computer Literacy", stateKey: "compLiteracy" },
  { type: "Textarea", label: "Explain Breaks (If Any)", stateKey: "explainBreak" },
  { type: "Textarea", label: "Certification / Courses (If Any)", stateKey: "certiCourses" },
  { type: "Textarea", label: "Subject of Special Study OR Research Work", stateKey: "specialStudy" },
  { type: "Textarea", label: "Special Skills", stateKey: "SpecialSkill" },
];

const employeeNomineeInputFields = [
  {
    type: "Textarea",
    label: "Nominee Name",
    stateKey: "nomineeName",
  },
  {
    type: "phoneNo",
    label: "Contact Number",
    stateKey: "nomineeContactNumber",
  },

  {
    type: "Autocomplete",
    label: "Relationship",
    stateKey: "relationship",
    options: [
      { id: 1, name: "Father" },
      { id: 2, name: "Mother" },
      { id: 3, name: "Husband" },
      { id: 4, name: "Wife" },
      { id: 5, name: "Son" },
      { id: 6, name: "Daughter" },
      { id: 7, name: "Brother" },
      { id: 8, name: "Sister" },
    ],
    valueKey: "name",
    getOptionLabelKey: "name",
  },
  { type: "emailId", label: "Email", stateKey: "NomineeEmailId" },
];

const employeeDocumentInputFields = [
  { type: "Textarea", label: "Aadhar ID ", stateKey: "aadharId" },
  {
    type: "ImageUpload",
    tooltipLabel: "Aadhar Card ",
    stateKey: "aadharUrl",
    label: "",
    downloadFile: true,
  },
  { type: "Textarea", label: "PAN ID ", stateKey: "panId" },
  {
    type: "ImageUpload",
    tooltipLabel: "PAN Card ",
    stateKey: "panUrl",
    label: "",
    downloadFile: true,
  },
  { type: "Textarea", label: "Passport ID", stateKey: "passportId" },
  {
    type: "ImageUpload",
    tooltipLabel: "Passport ",
    stateKey: "passportUrl",
    label: "",
    downloadFile: true,
  },
  { type: "Textarea", label: "Driver Licence ID", stateKey: "driverLicenceId" },
  {
    type: "ImageUpload",
    tooltipLabel: "Driver Licence ",
    stateKey: "driverLicenseUlr",
    label: "",
    downloadFile: true,
  },
  { type: "Textarea", label: "Bank Name ", stateKey: "bankName" },
  {
    type: "Textarea",
    label: "Bank Account Number ",
    stateKey: "bankAccountNumber",
  },
  { type: "Textarea", label: "IFSC Code ", stateKey: "ifscCode" },
  {
    type: "ImageUpload",
    tooltipLabel: "Cancel Cheque ",
    stateKey: "cancelCheckUrl",
    label: "",
    downloadFile: true,
  },
  { type: "Textarea", label: "Voter ID ", stateKey: "voterId" },
  {
    type: "ImageUpload",
    tooltipLabel: "Voter ID",
    stateKey: "voterIdUlr",
    label: "",
    downloadFile: true,
  },

  {
    type: "ImageUpload",
    tooltipLabel: "Induction Certificate",
    stateKey: "inductionCertificate",
    label: "Induction Certificate",
    downloadFile: true,
  },

  {
    type: "ImageUpload",
    tooltipLabel: "Signature",
    stateKey: "signature",
    label: "Signature",
  },
];

const employeeEmergencyDetailsInputFields = [
  {
    type: "Textarea",
    label: "Contact Person Name ",
    stateKey: "contactPersonName",
  },
  {
    type: "phoneNo",
    label: "Contact Number ",
    stateKey: "emergencyContactNumber",
  },

  {
    type: "phoneNo",
    label: "Alternative Contact Number ",
    stateKey: "emergencyAlternativeContactNumber",
  },
  { type: "emailId", label: "Email ", stateKey: "emergencyEmailId" },
  {
    type: "ImageUpload",
    tooltipLabel: "Aadhar ",
    stateKey: "emergencyAadharUrl",
    label: "Aadhar ",
    downloadFile: true,
  }, //aadharUrl
];

const initialColumns = [
  {
    id: "dependentName",
    label: "Dependent Name",
    accessor: "dependentName",
    dataType: "text",
  },
  {
    id: "relationship",
    label: "Relationship",
    accessor: "relationship",
    dataType: "text",
  },
  {
    id: "companyName",
    label: "Company Name",
    accessor: "companyName",
    dataType: "text",
  },
  {
    id: "policyNumber",
    label: "Policy Number",
    accessor: "policyNumber",
    dataType: "text",
  },
  {
    id: "fromDate",
    label: "From Date",
    accessor: "fromDate",
    dataType: "text",
  },
  {
    id: "toDate",
    label: "To Date",
    accessor: "toDate",
    dataType: "text",
  },
];

const EditEmployeeMaster = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate();
  const [inputStates, setInputStates] = React.useState({});
  const [beforeCalibrationData, setBeforeCalibrationData] = useState([]);
  const [experienceData, setExperienceData] = useState([]); // NEW: For multiple experience entries
  const [languageData, setLanguageData] = useState([
    { language: "English", speak: "Fluent", read: "Fluent", write: "Fluent" },
    { language: "Hindi", speak: "Fluent", read: "Fluent", write: "Fluent" },
    { language: "Marathi", speak: "Fluent", read: "Fluent", write: "Fluent" },
  ]);

  const updateLanguageState = (index, field, value) => {
    setLanguageData((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };
  const [employeeCount, setEmployeeCount] = useState(0);
  const [deletedRowIds, setDeletedRowIds] = useState([]);
  const [deletedExperienceIds, setDeletedExperienceIds] = useState([]); // NEW: Track deleted experience rows
  const [familyData, setFamilyData] = useState([
    { nomineeName: "", relationship: "", age: "", qualification: "", occupation: "", nomineeContactNumber: "", NomineeEmailId: "" },
  ]);
  const [deletedFamilyIds, setDeletedFamilyIds] = useState([]);
  const [refereesData, setRefereesData] = useState([
    { refereeName: "", contactNumber: "", positionHeld: "" },
  ]);
  const [deletedRefereeIds, setDeletedRefereeIds] = useState([]);
  const [downloadPdfloading, setDownlaodPdfLoading] = React.useState(false);
  const [districtOptions, setDistrictOptions] = React.useState([]);
  const [offerOptions, setOfferOptions] = React.useState([]);
  const [offersRaw, setOffersRaw] = React.useState([]);
  const _userType = Number(localStorage.getItem("type"));

  const fetchOffers = async () => {
    try {
      const [offers, pipelines, candidates, masters, existingEmployees] = await Promise.all([
        fetchQuery("SELECT * FROM talentAcqOffer WHERE status != -1"),
        fetchQuery("SELECT id, candId, candidateName FROM talentAcqPipeline"),
        fetchQuery("SELECT id, candidateName, mobileNo, emaiId, currentLocation, gender, employmentType FROM talentAcqCandidate"),
        fetchQuery("SELECT id, type, Value FROM talentAcquisitionMaster WHERE type = 2"),
        fetchQuery("SELECT offerId FROM employees WHERE status != -1 AND offerId IS NOT NULL AND offerId != ''"),
      ]);

      const usedOfferIds = (existingEmployees || [])
        .map((e) => e.offerId)
        .filter(Boolean);

      const rawList = [];
      const optList = [];

      (offers || []).forEach((o) => {
        const offerCode = o.offerId || `OID-${String(o.id).padStart(3, "0")}`;

        const isAlreadyUsed = usedOfferIds.includes(offerCode) || usedOfferIds.includes(String(o.id));
        const isCurrentRecordOffer = params.id != 0 && (inputStates.offerId === offerCode || inputStates.offerId == o.id);

        if (isAlreadyUsed && !isCurrentRecordOffer) {
          return;
        }

        const pipe = (pipelines || []).find((p) => p.id == o.pipelineId);
        const cand = (candidates || []).find((c) => c.id == (pipe?.candId || o.candId));

        const candidateName = o.candidateName || pipe?.candidateName || cand?.candidateName || `Candidate #${o.id}`;
        const mobile = cand?.mobileNo || "";
        const email = cand?.emaiId || "";
        const address = cand?.currentLocation || "";
        const gender = cand?.gender || o?.gender || "";

        let rawType = o.employmentType || cand?.employmentType || "";
        let resolvedEmpType = rawType;

        const matchedMaster = (masters || []).find((m) => m.id == rawType);
        if (matchedMaster) {
          resolvedEmpType = matchedMaster.Value;
        }

        const matchedOption = employeeTypeOptions.find(
          (opt) => opt.id == rawType || opt.name.toLowerCase() === String(resolvedEmpType).toLowerCase() || (String(resolvedEmpType).toLowerCase().includes("contract") && opt.id == 2) || (String(resolvedEmpType).toLowerCase().includes("payroll") && opt.id == 1)
        );

        const finalEmpType = matchedOption ? matchedOption.id : (rawType || "");

        const fullObj = {
          ...o,
          candidateName,
          mobile,
          email,
          address,
          gender,
          employeeType: finalEmpType,
          offerCode,
        };

        rawList.push(fullObj);
        optList.push({
          id: offerCode,
          name: `${offerCode} - ${candidateName}`,
        });
      });

      setOffersRaw(rawList);
      setOfferOptions(optList);
    } catch (err) {
      console.error("Error fetching offers for employee master:", err);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, [inputStates.offerId]);

  useEffect(() => {
    if (inputStates?.isExperienced === 2 && experienceData.length === 0) {
      setExperienceData([
        {
          companyName: "",
          designation: "",
          location: "",
          leavingReason: "",
          fromDate: "",
          toDate: "",
          workExpCertUrl: "",
          lastSalary: "",
          inHandCTC: "",
          hrNameContact: "",
        },
      ]);
    }
  }, [inputStates?.isExperienced]);

  useEffect(() => {
    if (inputStates.offerId && offersRaw.length > 0) {
      const selectedOffer = offersRaw.find(
        (o) => o.offerCode === inputStates.offerId || o.id == inputStates.offerId
      );
      if (selectedOffer) {
        setInputStates((prev) => ({
          ...prev,
          name: selectedOffer.candidateName || prev.name || "",
          contactNumber: selectedOffer.mobile || prev.contactNumber || "",
          emailAddress: selectedOffer.email || prev.emailAddress || "",
          officeEmailAddress: selectedOffer.email || prev.officeEmailAddress || "",
          currentAddress: selectedOffer.address || prev.currentAddress || "",
          dateOfJoining: (selectedOffer.actualJoiningDate ? selectedOffer.actualJoiningDate.split("T")[0] : prev.dateOfJoining) || "",
          gender: selectedOffer.gender || prev.gender || "",
          employeeType: selectedOffer.employeeType || prev.employeeType || "",
        }));
      }
    }
  }, [inputStates.offerId, offersRaw]);

  const inputFields = [
    {
      type: "TextField",
      label: "Employee Code *",
      stateKey: "employeesCode",
    },
    {
      type: "Autocomplete",
      label: "Offer ID",
      stateKey: "offerId",
      options: offerOptions,
      valueKey: "id",
      getOptionLabelKey: "name",
    },
    { type: "TextField", label: "Name *", stateKey: "name" },

    {
      type: "Textarea",
      label: "Permanent Address *",
      stateKey: "permenantAddress",
    },
    {
      type: "Textarea",
      label: "Current Address *",
      stateKey: "currentAddress",
    },
    {
      type: "Autocomplete",
      label: "State",
      stateKey: "state",
      options: statesList,
      valueKey: "label",
      getOptionLabelKey: "label",
    },
    {
      type: "Autocomplete",
      label: "Location",
      stateKey: "location",
      options: districtOptions,
      valueKey: "city",
      getOptionLabelKey: "city",
    },

    {
      type: "DatePicker",
      label: "Date Of Birth *",
      stateKey: "dateOfBirth",
      disableFutureDates: true,
    },
    {
      type: "DatePicker",
      label: "Date Of Joining *",
      stateKey: "dateOfJoining",
      disabled: ![1, 2, 8].includes(_userType),
    },
    { type: "phoneNo", label: "Contact Number *", stateKey: "contactNumber" },
    {
      type: "phoneNo",
      label: "Alternative Contact Number *",
      stateKey: "alternativeContactNumber",
    },
    { type: "emailId", label: "Email Address *", stateKey: "emailAddress" },
    {
      type: "emailId",
      label: "Office Email Address *",
      stateKey: "officeEmailAddress",
    },

    {
      type: "Autocomplete",
      label: "Gender *",
      stateKey: "gender",
      options: [
        { id: 1, name: "Male" },
        { id: 2, name: "Female" },
      ],
      valueKey: "name",
      getOptionLabelKey: "name",
    },

    {
      type: "Autocomplete",
      label: "Blood Group *",
      stateKey: "bloodGroup",
      options: [
        { id: 1, name: "A+" },
        { id: 2, name: "A-" },
        { id: 3, name: "B+" },
        { id: 4, name: "B-" },
        { id: 5, name: "AB+" },
        { id: 6, name: "AB-" },
        { id: 7, name: "O+" },
        { id: 8, name: "O-" },
      ],
      valueKey: "name",
      getOptionLabelKey: "name",
    },
    {
      type: "Autocomplete",
      label: "Marital Status *",
      stateKey: "maritalStatus",
      options: [
        { id: 1, name: "Married" },
        { id: 2, name: "Unmarried" },
      ],
      valueKey: "name",
      getOptionLabelKey: "name",
    },
  ];

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const fetchEmployeesDetails = async () => {
    try {
      const [employee] = await fetchQuery(
        `SELECT * FROM employees WHERE id = ${params.id}`,
      );

      const detailTables = [
        "employeeQualification",
        "employeeNominee",
        "employeeEmergencyDetails",
        "employeeOtherData",
        "employeeDocuments",
      ];

      const results = await Promise.all(
        detailTables.map((table) =>
          fetchQuery(`SELECT * FROM ${table} WHERE employeeId = ${params.id}`),
        ),
      );

      const mergedData = { ...employee };

      detailTables.forEach((table, index) => {
        const record = results[index][0];
        if (record) {
          Object.entries(record).forEach(([key, value]) => {
            if (key === "id") {
              mergedData[`${table}Id`] = value;
            } else if (!(key in mergedData)) {
              mergedData[key] = value;
            }
          });
        }
      });

      // NEW: Fetch all experience records
      const experienceRecords = await fetchQuery(
        `SELECT * FROM employeeExperience WHERE employeeId = ${params.id}`
      );

      if (experienceRecords && experienceRecords.length > 0) {
        setExperienceData(experienceRecords);
        mergedData.isExperienced = 2;
      } else {
        mergedData.isExperienced = 1;
        setExperienceData([]);
      }

      // Fetch all family background (employeeNominee) records
      const familyRecords = await fetchQuery(
        `SELECT * FROM employeeNominee WHERE employeeId = ${params.id}`
      );
      if (familyRecords && familyRecords.length > 0) {
        setFamilyData(familyRecords);
      } else {
        setFamilyData([
          { nomineeName: "", relationship: "", age: "", qualification: "", occupation: "", nomineeContactNumber: "", NomineeEmailId: "" },
        ]);
      }

      // Fetch all employeePreviousHistory records
      const prevHistRecords = await fetchQuery(
        `SELECT * FROM employeePreviousHistory WHERE employeeId = ${params.id}`
      );
      if (prevHistRecords && prevHistRecords.length > 0) {
        const mappedReferees = prevHistRecords.map((rec) => ({
          id: rec.id,
          refereeName: rec.Name || "",
          contactNumber: rec.contactNo || "",
          positionHeld: rec.positionHeld || "",
        }));
        setRefereesData(mappedReferees);

        const firstRec = prevHistRecords[0];
        mergedData.agreeRefereesContact = firstRec.refereeContacted || firstRec.refereesContacted || "";
        mergedData.workTypeAvailable = firstRec.workTypeAvailable || "";
        mergedData.noticePeriodOrJoiningDate = firstRec.joiningNoticeDate || firstRec.noticePeriodOrJoiningDate || "";
        mergedData.terminatedPastEmployer = firstRec.terminatedEmployer || firstRec.terminatedPastEmployer || "";
        mergedData.connectedWithBusiness = firstRec.connectedBusiness || firstRec.connectedWithBusiness || "";
        mergedData.ownHouseArrangement = firstRec.ownHouseArrangement || "";
        mergedData.serveIndiaAbroad = firstRec.serveIndiaAbroad || "";
        mergedData.friendsRelativesInDYC = firstRec.friendsInDYC || firstRec.friendsRelativesInDYC || "";
        mergedData.whoReferredDYC = firstRec.whoReferredDYC || "";
        mergedData.interviewedBeforeDYC = firstRec.interviewedDYC || firstRec.interviewedBeforeDYC || "";
        mergedData.interviewedBeforeDYCDate = firstRec.interviewedDYCDate || firstRec.interviewedBeforeDYCDate || "";
        mergedData.relativeInGovtOrg = firstRec.relativeGovtOrg || firstRec.relativeInGovtOrg || "";
        mergedData.relativeInGovtOrgDetails = firstRec.relativeGovtDetails || firstRec.relativeInGovtOrgDetails || "";
        mergedData.relativeOwnBusiness = firstRec.relativeBusiness || firstRec.relativeOwnBusiness || "";
        mergedData.relativeOwnBusinessDetails = firstRec.relativeBusinessDetails || firstRec.relativeOwnBusinessDetails || "";
        mergedData.potentialConflictOfInterest = firstRec.conflictOfInterest || firstRec.potentialConflictOfInterest || "";
      } else {
        setRefereesData([
          { refereeName: "", contactNumber: "", positionHeld: "" },
          { refereeName: "", contactNumber: "", positionHeld: "" },
          { refereeName: "", contactNumber: "", positionHeld: "" },
        ]);
      }

      if (mergedData.dependentCoveredDetails) {
        let parsedDetails = [];
        try {
          parsedDetails = JSON.parse(mergedData.dependentCoveredDetails) || [];
        } catch (err) {
          console.error("Error parsing dependentCoveredDetails:", err);
          parsedDetails = [];
        }
        setBeforeCalibrationData(parsedDetails);
        delete mergedData.dependentCoveredDetails;
      } else {
        setBeforeCalibrationData([]); // fallback empty array
      }

      const parseLangStr = (str) => {
        if (!str) return { speak: "Fluent", read: "Fluent", write: "Fluent" };
        const parts = String(str).split(",");
        return {
          speak: parts[0] || "Fluent",
          read: parts[1] || "Fluent",
          write: parts[2] || "Fluent",
        };
      };

      if (mergedData.engLang || mergedData.hindiLang || mergedData.marathiLang) {
        setLanguageData([
          { language: "English", ...parseLangStr(mergedData.engLang) },
          { language: "Hindi", ...parseLangStr(mergedData.hindiLang) },
          { language: "Marathi", ...parseLangStr(mergedData.marathiLang) },
        ]);
      } else if (mergedData.languageProficiency) {
        try {
          const parsed = typeof mergedData.languageProficiency === "string"
            ? JSON.parse(mergedData.languageProficiency)
            : mergedData.languageProficiency;
          if (Array.isArray(parsed) && parsed.length > 0) {
            setLanguageData(parsed);
          }
        } catch (err) {
          console.error("Error parsing languageProficiency:", err);
        }
      }

      if (mergedData.offerId) {
        try {
          const [offerRec] = await fetchQuery(
            `SELECT o.position AS offerPosition, p.position AS pipePosition 
             FROM talentAcqOffer o 
             LEFT JOIN talentAcqPipeline p ON (o.pipelineId = p.id OR o.pipelineId = p.pipelineId) 
             WHERE o.offerId = '${mergedData.offerId}' OR o.id = '${mergedData.offerId}'`
          );
          if (offerRec && (offerRec.offerPosition || offerRec.pipePosition)) {
            mergedData.hrDesignation = offerRec.offerPosition || offerRec.pipePosition || mergedData.hrDesignation;
            mergedData.designation = offerRec.offerPosition || offerRec.pipePosition || mergedData.designation;
          }
        } catch (e) {
          console.error("Error fetching offer position in editEmployeeMaster:", e);
        }
      }

      setInputStates(mergedData);
    } catch (error) {
      console.error("Error fetching employee details:", error);
    }
  };

  const employeeExperienceInputFields = [
    {
      type: "Autocomplete",
      label: "Is Experienced *",
      stateKey: "isExperienced",
      options: [
        { id: 1, name: "Fresher" },
        { id: 2, name: "Experienced" },
      ],
      valueKey: "id",
      getOptionLabelKey: "name",
    },
  ];

  const onlyForHrInputFields = [
    {
      type: "Autocomplete",
      label: "Employee Type",
      stateKey: "employeeType",
      options: employeeTypeOptions,
      valueKey: "id",
      getOptionLabelKey: "name",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "Designation",
      stateKey: "hrDesignation",
      options: designationOptions.sort((a, b) => a.name.localeCompare(b.name)),
      valueKey: "name",
      getOptionLabelKey: "name",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "Department",
      stateKey: "department",
      options: departmentOptions?.sort((a, b) => a.name.localeCompare(b.name)),
      valueKey: "name",
      getOptionLabelKey: "name",
      disabled: ![1, 2, 8].includes(_userType),
    },

    {
      type: "Autocomplete",
      label: "Reporting Manager",
      stateKey: "reportingManagerId",
      options: "employees",
      valueKey: "id",
      getOptionLabelKey: "name",
      optionsFilter: "where status = 1",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "Approval Manager",
      stateKey: "appprovalManagerId",
      options: "employees",
      valueKey: "id",
      getOptionLabelKey: "name",
      optionsFilter: "where status = 1",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "Approval Level 1",
      stateKey: "approvalLevel1Id",
      options: "employees",
      valueKey: "id",
      getOptionLabelKey: "name",
      optionsFilter: "where status = 1",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "Approval Level 2",
      stateKey: "approvalLevel2Id",
      options: "employees",
      valueKey: "id",
      getOptionLabelKey: "name",
      optionsFilter: "where status = 1",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "Branch",
      stateKey: "branchId",
      options: branchOptions,
      valueKey: "name",
      getOptionLabelKey: "name",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "Status",
      stateKey: "employeeStatus",
      options: HR_employeeStatus,
      valueKey: "id",
      getOptionLabelKey: "name",
      disabled: ![1, 2, 8].includes(_userType),
    },
    // {
    //   type: "emptySpace",
    //   stateKey: "",
    // },
    {
      type: "Checkbox",
      label: "PF Number",
      stateKey: "isPfNumber",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Checkbox",
      label: "ESIC Number",
      stateKey: "isEsicNumber",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Checkbox",
      label: "Insurance policy",
      stateKey: "isInsurance",
      disabled: ![1, 2, 8].includes(_userType),
    },

    {
      type: "emptySpace",
      stateKey: "",
    },

    ...(inputStates?.isPfNumber
      ? [
        {
          type: "Textarea",
          label: "PF Number",
          stateKey: "pfNumber",
          disabled: ![1, 2, 8].includes(_userType),
        },
      ]
      : []),
    ...(inputStates?.isEsicNumber
      ? [
        {
          type: "Textarea",
          label: "ESIC Number",
          stateKey: "esicNumber",
          disabled: ![1, 2, 8].includes(_userType),
        },
      ]
      : []),
    ...(() => {
      const pf = inputStates?.isPfNumber;
      const esic = inputStates?.isEsicNumber;
      let count = 0;
      if (pf && esic) count = 2;
      else if (pf || esic) count = 3;
      return Array.from({ length: count }, () => ({
        type: "emptySpace",
        label: "Insurance policy",
        stateKey: "",
      }));
    })(),
    ...(inputStates?.isInsurance
      ? [
        {
          type: "Textarea",
          label: "Company Name",
          stateKey: "insuranceCompanyName",
          disabled: ![1, 2, 8].includes(_userType),
        },
        {
          type: "Textarea",
          label: "Policy Number",
          stateKey: "policyNumber",
          disabled: ![1, 2, 8].includes(_userType),
        },
        {
          type: "DatePicker",
          label: "From Date",
          stateKey: "otherFromDate",
          disabled: ![1, 2, 8].includes(_userType),
        },
        {
          type: "DatePicker",
          label: "To Date",
          stateKey: "validDate",
          disabled: ![1, 2, 8].includes(_userType),
        },
        {
          type: "Autocomplete",
          label: "Dependent Covered",
          stateKey: "dependentCovered",
          options: [
            { id: 0, name: "No" },
            { id: 1, name: "Yes" },
          ],
          valueKey: "id",
          getOptionLabelKey: "name",
          disabled: ![1, 2, 8].includes(_userType),
        },
      ]
      : []),
  ];

  const filterByStateKeys = (fields, state) =>
    fields.reduce((acc, field) => {
      if (state.hasOwnProperty(field.stateKey)) {
        acc[field.stateKey] = state[field.stateKey];

        if (field.stateKey === "dependentCovered") {
          acc["dependentCoveredDetails"] = JSON.stringify(
            beforeCalibrationData,
          );
        }
      }
      return acc;
    }, {});

  const apiRequest = (endpoint, data, id) => {
    const url = `${BASE_URL}${endpoint}`;
    return id !== "0"
      ? axiosWithToken.patch(url + `/${id}`, data)
      : axiosWithToken.post(url, data);
  };

  const onSubmit = async () => {
    const fieldsToValidate = [
      // Personal Information
      { value: inputStates.employeesCode, label: "Employee Code is required" },
      { value: inputStates.name, label: "Name is required" },
      {
        value: inputStates.permenantAddress,
        label: "Permanent Address is required",
      },
      {
        value: inputStates.currentAddress,
        label: "Current Address is required",
      },
      { value: inputStates.dateOfBirth, label: "Date of Birth is required" },
      {
        value: inputStates.dateOfJoining,
        label: "Date of Joining is required",
      },
      { value: inputStates.contactNumber, label: "Contact Number is required" },
      {
        value: inputStates.alternativeContactNumber,
        label: "Alternative Contact Number is required",
      },
      { value: inputStates.emailAddress, label: "Email Address is required" },
      {
        value: inputStates.officeEmailAddress,
        label: "Office Email Address is required",
      },
      { value: inputStates.gender, label: "Gender is required" },
      { value: inputStates.maritalStatus, label: "Marital Status is required" },
    ];

    if (!validateRequiredFields(fieldsToValidate)) {
      return;
    }

    setDownlaodPdfLoading(true);

    try {
      const personal = {
        ...filterByStateKeys(inputFields, inputStates),
        physicalDisable: inputStates.physicalDisable || null,
        restriction: inputStates.restriction || null,
        majorIlnes: inputStates.majorIlnes || null,
        convicted: inputStates.convicted || null,
      };
      const employeeDetails = {
        personal,
        qualification: {
          ...filterByStateKeys(
            employeeQualificationInputFields,
            inputStates,
          ),
          ...filterByStateKeys(
            additionalQualificationInputFields,
            inputStates,
          ),
          undertakingStudy: inputStates.undertakingStudy || null,
        },
        nominee: filterByStateKeys(employeeNomineeInputFields, inputStates),
        emergency: filterByStateKeys(
          employeeEmergencyDetailsInputFields,
          inputStates,
        ),

        others: {
          ...filterByStateKeys(onlyForHrInputFields, inputStates),
          engLang: languageData.find((l) => l.language === "English") ? `${languageData.find((l) => l.language === "English").speak},${languageData.find((l) => l.language === "English").read},${languageData.find((l) => l.language === "English").write}` : "Fluent,Fluent,Fluent",
          hindiLang: languageData.find((l) => l.language === "Hindi") ? `${languageData.find((l) => l.language === "Hindi").speak},${languageData.find((l) => l.language === "Hindi").read},${languageData.find((l) => l.language === "Hindi").write}` : "Fluent,Fluent,Fluent",
          marathiLang: languageData.find((l) => l.language === "Marathi") ? `${languageData.find((l) => l.language === "Marathi").speak},${languageData.find((l) => l.language === "Marathi").read},${languageData.find((l) => l.language === "Marathi").write}` : "Fluent,Fluent,Fluent",
        },
        document: filterByStateKeys(employeeDocumentInputFields, inputStates),
      };
      // Format only these two fields:
      personal.dateOfBirth = personal.dateOfBirth
        ? moment(personal.dateOfBirth).format("YYYY-MM-DD")
        : null;

      personal.dateOfJoining = personal.dateOfJoining
        ? moment(personal.dateOfJoining).format("YYYY-MM-DD")
        : null;

      const res = await apiRequest("employees", employeeDetails.personal, params.id);
      const employeeId = params.id == 0 ? res.data?.insertId : params.id;

      const detailsMap = [
        {
          endpoint: "employeeQualification",
          data: employeeDetails.qualification,
          id: inputStates?.employeeQualificationId || "0",
        },
        {
          endpoint: "employeeEmergencyDetails",
          data: employeeDetails.emergency,
          id: inputStates?.employeeEmergencyDetailsId || "0",
        },
        {
          endpoint: "employeeOtherData",
          data: employeeDetails.others,
          id: inputStates?.employeeOtherDataId || "0",
        },
        {
          endpoint: "employeeDocuments",
          data: employeeDetails.document,
          id: inputStates?.employeeDocumentsId || "0",
        },
      ];

      // Run all API calls and wait for them
      await Promise.all(
        detailsMap.map(({ endpoint, data, id }) =>
          apiRequest(endpoint, { ...data, employeeId }, id),
        ),
      );

      // Handle Family Background (employeeNominee) multi-row data
      if (deletedFamilyIds.length > 0) {
        await Promise.all(
          deletedFamilyIds.map((id) =>
            axiosWithToken.delete(`${BASE_URL}employeeNominee/${id}`)
          )
        );
      }

      await Promise.all(
        familyData.map((fam) => {
          const famData = {
            nomineeName: fam.nomineeName || null,
            relationship: fam.relationship || null,
            age: fam.age || null,
            qualification: fam.qualification || null,
            occupation: fam.occupation || null,
            nomineeContactNumber: fam.nomineeContactNumber || null,
            NomineeEmailId: fam.NomineeEmailId || null,
            employeeId,
            staus: 1,
          };
          return apiRequest("employeeNominee", famData, fam.id || "0");
        })
      );

      // Handle Referees and Application Declarations (employeePreviousHistory)
      if (deletedRefereeIds.length > 0) {
        await Promise.all(
          deletedRefereeIds.map((id) =>
            axiosWithToken.delete(`${BASE_URL}employeePreviousHistory/${id}`)
          )
        );
      }

      const prevHistItems = (refereesData && refereesData.length > 0)
        ? refereesData
        : [{ refereeName: null, contactNumber: null, positionHeld: null }];

      await Promise.all(
        prevHistItems.map((ref) => {
          const refPayload = {
            employeeId,
            refereeContacted: inputStates.agreeRefereesContact || null,
            Name: ref.refereeName || null,
            contactNo: ref.contactNumber || null,
            positionHeld: ref.positionHeld || null,
            workTypeAvailable: inputStates.workTypeAvailable || null,
            joiningNoticeDate: inputStates.noticePeriodOrJoiningDate || null,
            terminatedEmployer: inputStates.terminatedPastEmployer || null,
            connectedBusiness: inputStates.connectedWithBusiness || null,
            ownHouseArrangement: inputStates.ownHouseArrangement || null,
            serveIndiaAbroad: inputStates.serveIndiaAbroad || null,
            friendsInDYC: inputStates.friendsRelativesInDYC || null,
            whoReferredDYC: inputStates.whoReferredDYC || null,
            interviewedDYC: inputStates.interviewedBeforeDYC || null,
            interviewedDYCDate: inputStates.interviewedBeforeDYCDate || null,
            relativeGovtOrg: inputStates.relativeInGovtOrg || null,
            relativeGovtDetails: inputStates.relativeInGovtOrgDetails || null,
            relativeBusiness: inputStates.relativeOwnBusiness || null,
            relativeBusinessDetails: inputStates.relativeOwnBusinessDetails || null,
            conflictOfInterest: inputStates.potentialConflictOfInterest || null,
            status: 1,
          };
          return apiRequest("employeePreviousHistory", refPayload, ref.id || "0");
        })
      );

      // NEW: Handle experience data
      if (inputStates.isExperienced == 2) {
        // Delete removed experience entries
        if (deletedExperienceIds.length > 0) {
          await Promise.all(
            deletedExperienceIds.map((id) =>
              axiosWithToken.delete(`${BASE_URL}employeeExperience/${id}`)
            )
          );
        }
        // Save/update experience entries
        await Promise.all(
          experienceData.map((exp) => {
            const expData = {
              companyName: exp.companyName,
              designation: exp.designation,
              location: exp.location || null,
              leavingReason: exp.leavingReason || null,
              fromDate: exp.fromDate ? moment(exp.fromDate).format("YYYY-MM-DD") : null,
              toDate: exp.toDate ? moment(exp.toDate).format("YYYY-MM-DD") : null,
              workExpCertUrl: exp.workExpCertUrl,
              lastSalary: exp.lastSalary || null,
              inHandCTC: exp.inHandCTC || null,
              hrNameContact: exp.hrNameContact || null,
              employeeId,
            };
            return apiRequest("employeeExperience", expData, exp.id || "0");
          })
        );
      } else {
        // If fresher, delete all existing experience records
        if (params.id != 0) {
          const existingExp = await fetchQuery(
            `SELECT id FROM employeeExperience WHERE employeeId = ${employeeId}`
          );
          if (existingExp && existingExp.length > 0) {
            await Promise.all(
              existingExp.map((exp) =>
                axiosWithToken.delete(`${BASE_URL}employeeExperience/${exp.id}`)
              )
            );
          }
        }
      }
      setDownlaodPdfLoading(false);

      toast.success(
        params.id !== "0"
          ? "Employees Updated Successfully!"
          : "Employees Created Successfully!",
      );
      if (params.id == 0) {
        setTimeout(() => navigate("/master/employeeMaster"), 1000);
      } else {
        reloadPage();
      }
    } catch (error) {
      setDownlaodPdfLoading(false);
      console.error("Submit error:", error);
    }
  };

  const fetchCountEmployee = async () => {
    const employeeCount = await fetchCountOfTable("employees/count");
    setEmployeeCount(employeeCount);
  };

  const reloadPage = () => {
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  useEffect(() => {
    if (params.id == 0) {
      updateInputObject(
        "employeesCode",
        `${employeeUnicode}${String(employeeCount + 1)}`,
      );
    }
  }, [employeeCount, employeeUnicode, params.id]);

  useEffect(() => {
    fetchOffers();
  }, []);

  useEffect(() => {
    if (inputStates.offerId && offersRaw.length > 0) {
      const selectedOffer = offersRaw.find(
        (o) => o.offerCode === inputStates.offerId || o.offerId === inputStates.offerId
      );
      if (selectedOffer) {
        const nameVal = selectedOffer.candidateName || "";
        const mobileVal = selectedOffer.mobile || "";
        const emailVal = selectedOffer.email || "";
        const addressVal = selectedOffer.address || "";
        let joiningDateVal = selectedOffer.confirmedJoiningDate || selectedOffer.actualJoiningDate || selectedOffer.offerDate || "";
        if (joiningDateVal && joiningDateVal.includes("T")) {
          joiningDateVal = joiningDateVal.split("T")[0];
        }

        setInputStates((prev) => ({
          ...prev,
          name: nameVal || prev.name || "",
          contactNumber: mobileVal || prev.contactNumber || "",
          emailAddress: emailVal || prev.emailAddress || "",
          officeEmailAddress: emailVal || prev.officeEmailAddress || "",
          currentAddress: addressVal || prev.currentAddress || "",
          dateOfJoining: joiningDateVal || prev.dateOfJoining || "",
        }));
      }
    }
  }, [inputStates.offerId, offersRaw]);

  useEffect(() => {
    const selectedState = statesList.find(
      (s) => s.label === inputStates.state
    );
    if (selectedState?.district) {
      setDistrictOptions(selectedState.district);
    } else {
      setDistrictOptions([]);
    }
  }, [inputStates.state]);

  //   useEffect(() => {
  //   if (params.id == 0 && inputStates?.permenantAddress) {
  //     updateInputObject("currentAddress", inputStates.permenantAddress);
  //   }
  // }, [inputStates?.permenantAddress, params.id]);

  useEffect(() => {
    if (params.id != 0) {
      fetchEmployeesDetails();
    } else {
      fetchCountEmployee();
    }
  }, [params]);

  // NEW: Clear experience data when switching to Fresher
  useEffect(() => {
    if (inputStates.isExperienced == 1) {
      setExperienceData([]);
    }
  }, [inputStates.isExperienced]);

  const handleDownload = async () => {
    try {
      setDownlaodPdfLoading(true);
      const mergedData = {
        ...inputStates,
        experienceList: experienceData || [],
        familyMembers: familyData || [],
        referees: (refereesData || []).map((r) => ({
          name: r.refereeName || r.Name || "",
          contactNo: r.contactNumber || r.contactNo || "",
          position: r.positionHeld || "",
        })),
      };

      const pdf = await generateApplicationFormPDF(mergedData);
      const safeName = (inputStates?.name || "Employee").replace(/[^a-zA-Z0-9_-]/g, "_");
      pdf.save(`Application_Form_${safeName}.pdf`);
    } catch (error) {
      console.error("Error generating application form PDF:", error);
      toast.error("Failed to generate Application Form PDF");
    } finally {
      setDownlaodPdfLoading(false);
    }
  };

  return (
    <div>
      {(permissions.pdfDownload || permissions.allAccess) && params.id != 0 && (
        <div className="flex justify-end mb-4 gap-3">
          <AddButton
            id="btn-download-pdf"
            hoverTitle="Download PDF"
            icon={<DownloadIcon fontSize="small" />}
            onClick={() => handleDownload()}
          />
        </div>
      )}

      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Employee" : `Update Employee `}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />

      {/* Inline Declarations Table right below Marital Status */}
      <div className="bg-white border border-gray-300 rounded-md p-3 my-4">
        <table className="w-full text-sm border-collapse">
          <tbody>
            {[
              {
                id: "physicalDisable",
                question: "Physical disability:",
                placeholder: "If any pls Specify:",
              },
              {
                id: "restriction",
                question: "Restrictions on activities for health reasons:",
                placeholder: "If any on activities for health reasons:",
              },
              {
                id: "majorIlnes",
                question: "Specify Major illness or operations, if any:",
                placeholder: "Specify if any:",
              },
              {
                id: "convicted",
                question: "Have you ever been convicted ?(Ignore minor traffic offences):",
                placeholder: "If Yes pls specify:",
              },
            ].map((item, idx) => {
              const currentVal = inputStates[item.id] || "";
              const lowerVal = String(currentVal).trim().toLowerCase();
              const isYes = lowerVal === "yes" || lowerVal.startsWith("yes");
              const isNo = !isYes;
              const detailsText = (lowerVal === "no" || lowerVal === "yes" || lowerVal === "")
                ? ""
                : currentVal.replace(/^yes\s*[-:\s]*/i, "");

              const handleChoice = (choice) => {
                if (choice === "Yes") {
                  updateInputObject(item.id, detailsText ? `Yes - ${detailsText}` : "Yes");
                } else {
                  updateInputObject(item.id, "No");
                }
              };

              const handleText = (e) => {
                const text = e.target.value;
                if (isYes) {
                  updateInputObject(item.id, text ? `Yes - ${text}` : "Yes");
                } else {
                  updateInputObject(item.id, "No");
                }
              };

              return (
                <tr key={item.id} className="border-b border-gray-200">
                  <td className="py-2.5 px-2 font-medium text-gray-800 w-1/2 align-top">
                    {idx + 1}. {item.question}
                  </td>
                  <td className="py-2.5 px-2 w-1/2 align-top">
                    <div className="flex items-center space-x-6 mb-1.5">
                      <label className="inline-flex items-center space-x-1.5 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={isYes}
                          onChange={() => handleChoice("Yes")}
                          className="h-4 w-4 text-blue-600 rounded cursor-pointer"
                        />
                        <span className="text-xs font-semibold text-gray-700">Yes</span>
                      </label>
                      <label className="inline-flex items-center space-x-1.5 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={isNo}
                          onChange={() => handleChoice("No")}
                          className="h-4 w-4 text-blue-600 rounded cursor-pointer"
                        />
                        <span className="text-xs font-semibold text-gray-700">No</span>
                      </label>
                    </div>
                    <input
                      type="text"
                      placeholder={item.placeholder}
                      disabled={!isYes}
                      value={isYes ? detailsText : ""}
                      onChange={handleText}
                      className={`w-full border border-gray-300 rounded px-2.5 py-1 text-xs focus:outline-none ${!isYes ? "bg-gray-100 cursor-not-allowed text-gray-400" : "focus:border-blue-500"
                        }`}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br />



      <hr />
      <br />
      <Text variant="h3" bold className="text-blue-600">
        Qualification
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={employeeQualificationInputFields}
      />
      <br />
      <br />

      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={additionalQualificationInputFields}
      />

      {/* Undertaking Study/Training Section */}
      <div className="bg-white border border-gray-300 rounded-md p-4 mt-6 mb-6 shadow-sm">
        <div className="mb-3">
          <label className="font-semibold text-sm text-gray-800 block mb-2">
            Are you currently undertaking study/training? (tick one):
          </label>
          <div className="flex items-center space-x-6">
            <label className="inline-flex items-center space-x-2 cursor-pointer text-sm font-medium">
              <input
                type="radio"
                name="undertakingStudyRadio"
                checked={String(inputStates.undertakingStudy || "").startsWith("Yes")}
                onChange={() => {
                  const currentStr = String(inputStates.undertakingStudy || "");
                  const parts = currentStr.split("-");
                  const prog = parts[1] ? parts[1].trim() : "Full time";
                  updateInputObject("undertakingStudy", `Yes - ${prog}`);
                }}
                className="h-4 w-4 text-blue-600 cursor-pointer"
              />
              <span>Yes</span>
            </label>
            <label className="inline-flex items-center space-x-2 cursor-pointer text-sm font-medium">
              <input
                type="radio"
                name="undertakingStudyRadio"
                checked={!String(inputStates.undertakingStudy || "").startsWith("Yes")}
                onChange={() => {
                  updateInputObject("undertakingStudy", "No");
                }}
                className="h-4 w-4 text-blue-600 cursor-pointer"
              />
              <span>No</span>
            </label>
          </div>
        </div>

        {String(inputStates.undertakingStudy || "").startsWith("Yes") && (
          <div className="mt-3 pt-3 border-t border-gray-200">
            <label className="font-semibold text-xs text-gray-700 block mb-2">
              If yes, course/program name: (tick one)
            </label>
            <div className="flex flex-wrap gap-6">
              {["Full time", "Part time", "Distance", "Other"].map((prog) => {
                const currentStr = String(inputStates.undertakingStudy || "");
                const isSelected = currentStr.includes(prog);
                return (
                  <label key={prog} className="inline-flex items-center space-x-2 cursor-pointer text-xs font-medium">
                    <input
                      type="radio"
                      name="undertakingProgramRadio"
                      checked={isSelected}
                      onChange={() => {
                        updateInputObject("undertakingStudy", `Yes - ${prog}`);
                      }}
                      className="h-4 w-4 text-blue-600 cursor-pointer"
                    />
                    <span>{prog}</span>
                  </label>
                );
              })}
            </div>
          </div>
        )}
      </div>
      <br />
      <br />
      <hr />
      <br />
      <div className="flex justify-between items-center mb-4">
        <Text variant="h3" bold className="text-blue-600">
          Experience
        </Text>
        {inputStates?.isExperienced === 2 && (
          <SaveAndUpdate
            label="Add Experience"
            onClick={() => {
              setExperienceData([
                ...experienceData,
                {
                  companyName: "",
                  designation: "",
                  location: "",
                  leavingReason: "",
                  fromDate: "",
                  toDate: "",
                  workExpCertUrl: "",
                  lastSalary: "",
                  inHandCTC: "",
                  hrNameContact: "",
                },
              ]);
            }}
          />
        )}
      </div>
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={employeeExperienceInputFields}
      />
      <br />

      {/* NEW: Experience entries for multiple work experience */}
      {inputStates?.isExperienced === 2 && (
        <>
          {experienceData.map((exp, index) => (
            <div key={index} style={{ marginBottom: "20px", padding: "15px", border: "1px solid #ddd", borderRadius: "8px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                <Text variant="h5" bold>Experience {index + 1}</Text>
                {experienceData.length > 1 && (
                  <CancelButton
                    label="Remove"
                    onClick={() => {
                      if (exp.id) {
                        setDeletedExperienceIds([...deletedExperienceIds, exp.id]);
                      }
                      setExperienceData(experienceData.filter((_, i) => i !== index));
                    }}
                  />
                )}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 xl:grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_auto] gap-3 items-center">
                <TextFields
                  label="Company Name *"
                  value={exp.companyName || ""}
                  onChange={(e) => {
                    const newData = [...experienceData];
                    newData[index].companyName = e.target.value;
                    setExperienceData(newData);
                  }}
                  multiline
                  minRows={1}
                  maxRows={10}
                />
                <TextFields
                  label="Designation *"
                  value={exp.designation || ""}
                  onChange={(e) => {
                    const newData = [...experienceData];
                    newData[index].designation = e.target.value;
                    setExperienceData(newData);
                  }}
                  multiline
                  minRows={1}
                  maxRows={10}
                />
                <TextFields
                  label="Location"
                  value={exp.location || ""}
                  onChange={(e) => {
                    const newData = [...experienceData];
                    newData[index].location = e.target.value;
                    setExperienceData(newData);
                  }}
                />
                <TextFields
                  label="Reason for Leaving"
                  value={exp.leavingReason || ""}
                  onChange={(e) => {
                    const newData = [...experienceData];
                    newData[index].leavingReason = e.target.value;
                    setExperienceData(newData);
                  }}
                />
                <DateInput
                  label="From Date *"
                  value={exp.fromDate || ""}
                  onChange={(date) => {
                    const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
                    const newData = [...experienceData];
                    newData[index].fromDate = formattedDate;
                    setExperienceData(newData);
                  }}
                />
                <DateInput
                  label="To Date *"
                  value={exp.toDate || ""}
                  onChange={(date) => {
                    const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
                    const newData = [...experienceData];
                    newData[index].toDate = formattedDate;
                    setExperienceData(newData);
                  }}
                />
                <UploadButton
                  label=""
                  tooltipLabel="Work Experience Certificate"
                  downloadFile={true}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file && /[&#$*]/.test(file.name)) {
                      toast.warning("File name contains special characters. Please rename the file and upload again.");
                      return;
                    }
                    const data = new FormData();
                    data.append("fileToUpload", file);
                    axiosWithToken
                      .post(BASE_URL + `fileUpload/fileUpload.php`, data)
                      .then((res) => {
                        if (res.status == 200) {
                          const newData = [...experienceData];
                          newData[index].workExpCertUrl = res.data;
                          setExperienceData(newData);
                          toast.success("File Uploaded Successfully!");
                        }
                      })
                      .catch(() => toast.error("Something went wrong"));
                  }}
                  outline={false}
                  fileUrl={exp.workExpCertUrl}
                  showFile={true}
                  onRemove={() => {
                    const newData = [...experienceData];
                    newData[index].workExpCertUrl = null;
                    setExperienceData(newData);
                  }}
                />
              </div>

              {/* Row 2: Salary and HR contact details */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-3 pt-3 border-t border-gray-200">
                <TextFields
                  label="Last Salary (In Hand PM)"
                  value={exp.lastSalary || ""}
                  onChange={(e) => {
                    const newData = [...experienceData];
                    newData[index].lastSalary = e.target.value;
                    setExperienceData(newData);
                  }}
                />
                <TextFields
                  label="In Hand CTC (CTC Per Annum)"
                  value={exp.inHandCTC || ""}
                  onChange={(e) => {
                    const newData = [...experienceData];
                    newData[index].inHandCTC = e.target.value;
                    setExperienceData(newData);
                  }}
                />
                <TextFields
                  label="HR Name & Contact Details (From Last Company)"
                  value={exp.hrNameContact || ""}
                  onChange={(e) => {
                    const newData = [...experienceData];
                    newData[index].hrNameContact = e.target.value;
                    setExperienceData(newData);
                  }}
                />
              </div>
            </div>
          ))}
          <br />
        </>
      )}

      <hr />
      <br />
      <div className="flex justify-between items-center mb-4">
        <Text variant="h3" bold className="text-blue-600">
          Family Background
        </Text>
        <SaveAndUpdate
          label="Add Family"
          onClick={() => {
            setFamilyData([
              ...familyData,
              {
                nomineeName: "",
                relationship: "",
                age: "",
                qualification: "",
                occupation: "",
                nomineeContactNumber: "",
                NomineeEmailId: "",
              },
            ]);
          }}
        />
      </div>

      {familyData.map((fam, index) => (
        <div key={index} style={{ marginBottom: "20px", padding: "15px", border: "1px solid #ddd", borderRadius: "8px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
            <Text variant="h5" bold>Family Member {index + 1}</Text>
            {familyData.length > 1 && (
              <CancelButton
                label="Remove"
                onClick={() => {
                  if (fam.id) {
                    setDeletedFamilyIds([...deletedFamilyIds, fam.id]);
                  }
                  setFamilyData(familyData.filter((_, i) => i !== index));
                }}
              />
            )}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7 gap-4">
            <TextFields
              label="Name"
              value={fam.nomineeName || ""}
              onChange={(e) => {
                const newData = [...familyData];
                newData[index].nomineeName = e.target.value;
                setFamilyData(newData);
              }}
            />
            <AutoCompletes
              label="Relationship"
              options={["Father", "Mother", "Husband", "Wife", "Son", "Daughter", "Brother", "Sister"]}
              value={fam.relationship || ""}
              onChange={(val) => {
                const selectedVal = typeof val === "string" ? val : (val?.value || val?.label || "");
                const newData = [...familyData];
                newData[index].relationship = selectedVal;
                setFamilyData(newData);
              }}
            />
            <TextFields
              label="Age"
              value={fam.age || ""}
              onChange={(e) => {
                const newData = [...familyData];
                newData[index].age = e.target.value;
                setFamilyData(newData);
              }}
            />
            <TextFields
              label="Qualification"
              value={fam.qualification || ""}
              onChange={(e) => {
                const newData = [...familyData];
                newData[index].qualification = e.target.value;
                setFamilyData(newData);
              }}
            />
            <TextFields
              label="Occupation"
              value={fam.occupation || ""}
              onChange={(e) => {
                const newData = [...familyData];
                newData[index].occupation = e.target.value;
                setFamilyData(newData);
              }}
            />
            <TextFields
              label="Contact Number"
              value={fam.nomineeContactNumber || ""}
              onChange={(e) => {
                const newData = [...familyData];
                newData[index].nomineeContactNumber = e.target.value;
                setFamilyData(newData);
              }}
            />
            <TextFields
              label="Email"
              value={fam.NomineeEmailId || ""}
              onChange={(e) => {
                const newData = [...familyData];
                newData[index].NomineeEmailId = e.target.value;
                setFamilyData(newData);
              }}
            />
          </div>
        </div>
      ))}
      <br />

      <hr />
      <br />
      <Text variant="h3" bold className="text-blue-600">
        Emergency Details
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={employeeEmergencyDetailsInputFields}
      />
      <br />

      <hr />
      <br />
      <Text variant="h3" bold className="text-blue-600">
        Document
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={employeeDocumentInputFields}
      />
      <br />

      <hr />
      <br />

      <Text variant="h3" bold className="text-blue-600">
        Language Proficiency
      </Text>
      <br />
      <div className="overflow-x-auto mb-6 bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
        <table className="w-full border-collapse border border-gray-300 text-sm">
          <thead>
            <tr className="bg-gray-100 font-bold border-b border-gray-900">
              <th className="border border-gray-300 p-2 text-left w-1/4">Language</th>
              <th className="border border-gray-300 p-2 text-center" colSpan={3}>Speak</th>
              <th className="border border-gray-300 p-2 text-center" colSpan={3}>Read</th>
              <th className="border border-gray-300 p-2 text-center" colSpan={3}>Write</th>
            </tr>
            <tr className="bg-gray-50 text-xs font-semibold">
              <th className="border border-gray-300 p-2"></th>
              <th className="border border-gray-300 p-1 text-center">Fluent</th>
              <th className="border border-gray-300 p-1 text-center">Fair</th>
              <th className="border border-gray-300 p-1 text-center">Poor</th>
              <th className="border border-gray-300 p-1 text-center">Fluent</th>
              <th className="border border-gray-300 p-1 text-center">Fair</th>
              <th className="border border-gray-300 p-1 text-center">Poor</th>
              <th className="border border-gray-300 p-1 text-center">Fluent</th>
              <th className="border border-gray-300 p-1 text-center">Fair</th>
              <th className="border border-gray-300 p-1 text-center">Poor</th>
            </tr>
          </thead>
          <tbody>
            {languageData.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="border border-gray-300 p-2 font-bold text-gray-800">{item.language}</td>

                {/* Speak */}
                {["Fluent", "Fair", "Poor"].map((level) => (
                  <td key={`speak-${level}`} className="border border-gray-300 p-2 text-center">
                    <input
                      type="radio"
                      name={`speak-${index}`}
                      checked={item.speak === level}
                      onChange={() => updateLanguageState(index, "speak", level)}
                      className="h-4 w-4 text-blue-600 cursor-pointer"
                    />
                  </td>
                ))}

                {/* Read */}
                {["Fluent", "Fair", "Poor"].map((level) => (
                  <td key={`read-${level}`} className="border border-gray-300 p-2 text-center">
                    <input
                      type="radio"
                      name={`read-${index}`}
                      checked={item.read === level}
                      onChange={() => updateLanguageState(index, "read", level)}
                      className="h-4 w-4 text-blue-600 cursor-pointer"
                    />
                  </td>
                ))}

                {/* Write */}
                {["Fluent", "Fair", "Poor"].map((level) => (
                  <td key={`write-${level}`} className="border border-gray-300 p-2 text-center">
                    <input
                      type="radio"
                      name={`write-${index}`}
                      checked={item.write === level}
                      onChange={() => updateLanguageState(index, "write", level)}
                      className="h-4 w-4 text-blue-600 cursor-pointer"
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <br />

      <hr />
      <br />

      {/* NEW SECTION: Referees & Application Declarations */}
      <Text variant="h3" bold className="text-blue-600">
        Referees & Application Declarations
      </Text>
      <br />

      {/* 1. Referees Contact Consent & Referees Table */}
      <div className="bg-white border border-gray-300 rounded-md p-4 mb-6 shadow-sm">
        <div className="mb-4">
          <label className="font-semibold text-sm text-gray-800 block mb-2">
            Do you agree to have referees contacted in relation to this application? (tick one):
          </label>
          <div className="flex items-center space-x-6">
            <label className="inline-flex items-center space-x-2 cursor-pointer text-sm font-medium">
              <input
                type="radio"
                name="agreeRefereesContactRadio"
                checked={inputStates.agreeRefereesContact === "Yes"}
                onChange={() => updateInputObject("agreeRefereesContact", "Yes")}
                className="h-4 w-4 text-blue-600 cursor-pointer"
              />
              <span>Yes</span>
            </label>
            <label className="inline-flex items-center space-x-2 cursor-pointer text-sm font-medium">
              <input
                type="radio"
                name="agreeRefereesContactRadio"
                checked={inputStates.agreeRefereesContact === "No"}
                onChange={() => updateInputObject("agreeRefereesContact", "No")}
                className="h-4 w-4 text-blue-600 cursor-pointer"
              />
              <span>No</span>
            </label>
          </div>
          <p className="text-xs italic text-gray-500 mt-1">
            (Reference checks will be conducted legally in an ethical manner and all information derived will remain confidential.)
          </p>
        </div>

        <div className="flex justify-between items-center mb-3 pt-3 border-t border-gray-200">
          <label className="font-semibold text-sm text-gray-800">
            Please provide details of three people who can speak on your behalf regarding your work history:
          </label>
          <SaveAndUpdate
            label="Add Referee"
            onClick={() => {
              setRefereesData([
                ...refereesData,
                { refereeName: "", contactNumber: "", positionHeld: "" },
              ]);
            }}
          />
        </div>

        {refereesData.map((ref, index) => (
          <div key={index} style={{ marginBottom: "15px", padding: "12px", border: "1px solid #ddd", borderRadius: "8px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
              <Text variant="h6" bold>Referee {index + 1}</Text>
              {refereesData.length > 1 && (
                <CancelButton
                  label="Remove"
                  onClick={() => {
                    if (ref.id) {
                      setDeletedRefereeIds([...deletedRefereeIds, ref.id]);
                    }
                    setRefereesData(refereesData.filter((_, i) => i !== index));
                  }}
                />
              )}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <TextFields
                label="Name"
                value={ref.refereeName || ""}
                onChange={(e) => {
                  const newData = [...refereesData];
                  newData[index].refereeName = e.target.value;
                  setRefereesData(newData);
                }}
              />
              <TextFields
                label="Contact No."
                value={ref.contactNumber || ""}
                onChange={(e) => {
                  const newData = [...refereesData];
                  newData[index].contactNumber = e.target.value;
                  setRefereesData(newData);
                }}
              />
              <TextFields
                label="Position held / working relationship"
                value={ref.positionHeld || ""}
                onChange={(e) => {
                  const newData = [...refereesData];
                  newData[index].positionHeld = e.target.value;
                  setRefereesData(newData);
                }}
              />
            </div>
          </div>
        ))}
      </div>

      {/* 2. Availability & Notice Period */}
      <div className="bg-white border border-gray-300 rounded-md p-4 mb-6 shadow-sm">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <label className="font-semibold text-sm text-gray-800 block mb-2">
              What type of work are you available for? (tick one):
            </label>
            <div className="flex items-center space-x-6">
              {["Full time", "Part Time", "On Call Basis"].map((type) => (
                <label key={type} className="inline-flex items-center space-x-2 cursor-pointer text-sm font-medium">
                  <input
                    type="radio"
                    name="workTypeAvailableRadio"
                    checked={inputStates.workTypeAvailable === type}
                    onChange={() => updateInputObject("workTypeAvailable", type)}
                    className="h-4 w-4 text-blue-600 cursor-pointer"
                  />
                  <span>{type}</span>
                </label>
              ))}
            </div>
          </div>

          <TextFields
            label="Notice to be serve current company or Joining Date"
            value={inputStates.noticePeriodOrJoiningDate || ""}
            onChange={(e) => updateInputObject("noticePeriodOrJoiningDate", e.target.value)}
          />
        </div>
      </div>

      {/* 3. Declarations Table */}
      <div className="overflow-x-auto mb-6 bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
        <table className="w-full border-collapse border border-gray-300 text-sm">
          <thead>
            <tr className="bg-gray-100 font-bold border-b border-gray-900">
              <th className="border border-gray-300 p-2 text-left w-1/2">Declaration Questions</th>
              <th className="border border-gray-300 p-2 text-center w-1/6">Yes</th>
              <th className="border border-gray-300 p-2 text-center w-1/6">No</th>
              <th className="border border-gray-300 p-2 text-left w-1/3">Details (If Any / Specify)</th>
            </tr>
          </thead>
          <tbody>
            {[
              {
                label: "Have you ever been terminated by your past employer?",
                stateKey: "terminatedPastEmployer",
              },
              {
                label: "Are you connected with any business?",
                stateKey: "connectedWithBusiness",
              },
              {
                label: "Are you in position to make your own house arrangement?",
                stateKey: "ownHouseArrangement",
              },
              {
                label: "Are you prepared to service anywhere in India & Abroad?",
                stateKey: "serveIndiaAbroad",
              },
              {
                label: "Do you have any friends or relatives in DYC Global?",
                stateKey: "friendsRelativesInDYC",
              },
              {
                label: "Have you been interviewed before by DYC Global?",
                stateKey: "interviewedBeforeDYC",
                detailKey: "interviewedBeforeDYCDate",
                detailLabel: "If Yes pls specify Date",
              },
              {
                label: "Do you have any relative working in Govt. Organization?",
                stateKey: "relativeInGovtOrg",
                detailKey: "relativeInGovtOrgDetails",
                detailLabel: "If Yes pls specify Name of relative & working Dept.",
              },
              {
                label: "Do you have any relatives who own a company or business?",
                stateKey: "relativeOwnBusiness",
                detailKey: "relativeOwnBusinessDetails",
                detailLabel: "If Yes pls specify Name of relative & Company Name & Nature of Business",
              },
            ].map((q, idx) => (
              <tr key={idx} className="hover:bg-gray-50">
                <td className="border border-gray-300 p-2 font-medium text-gray-800">{q.label}</td>
                <td className="border border-gray-300 p-2 text-center">
                  <input
                    type="radio"
                    name={`decl-${q.stateKey}`}
                    checked={inputStates[q.stateKey] === "Yes"}
                    onChange={() => updateInputObject(q.stateKey, "Yes")}
                    className="h-4 w-4 text-blue-600 cursor-pointer"
                  />
                </td>
                <td className="border border-gray-300 p-2 text-center">
                  <input
                    type="radio"
                    name={`decl-${q.stateKey}`}
                    checked={inputStates[q.stateKey] === "No"}
                    onChange={() => {
                      updateInputObject(q.stateKey, "No");
                      if (q.detailKey) {
                        updateInputObject(q.detailKey, "");
                      }
                    }}
                    className="h-4 w-4 text-blue-600 cursor-pointer"
                  />
                </td>
                <td className="border border-gray-300 p-2">
                  {q.detailKey && (
                    <input
                      type="text"
                      placeholder={q.detailLabel || "Specify..."}
                      disabled={inputStates[q.stateKey] !== "Yes"}
                      value={inputStates[q.stateKey] === "Yes" ? (inputStates[q.detailKey] || "") : ""}
                      onChange={(e) => updateInputObject(q.detailKey, e.target.value)}
                      className={`w-full border border-gray-300 rounded px-2 py-1 text-xs ${inputStates[q.stateKey] !== "Yes" ? "bg-gray-100 cursor-not-allowed text-gray-400" : ""
                        }`}
                    />
                  )}
                </td>
              </tr>
            ))}
            <tr>
              <td className="border border-gray-300 p-2 font-medium text-gray-800" colSpan={4}>
                <div className="mt-1">
                  <label className="block text-xs font-semibold text-gray-700 mb-1">
                    Who referred you DYC? (Specify Name & Relation):
                  </label>
                  <input
                    type="text"
                    placeholder="Specify Name & Relation..."
                    value={inputStates.whoReferredDYC || ""}
                    onChange={(e) => updateInputObject("whoReferredDYC", e.target.value)}
                    className="w-full border border-gray-300 rounded px-2 py-1 text-xs"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2 font-medium text-gray-800" colSpan={4}>
                <div className="mt-1">
                  <label className="block text-xs font-semibold text-gray-700 mb-1">
                    Details of Potential Conflict of Interest (if any): (Write "None" if no potential COI exists.)
                  </label>
                  <textarea
                    rows={2}
                    placeholder="Write 'None' if no potential COI exists..."
                    value={inputStates.potentialConflictOfInterest || ""}
                    onChange={(e) => updateInputObject("potentialConflictOfInterest", e.target.value)}
                    className="w-full border border-gray-300 rounded px-2 py-1 text-xs"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />

      <hr />
      <br />


      <Text variant="h3" bold className="text-blue-600">
        Only For HR
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={onlyForHrInputFields}
      />
      <br />

      {inputStates?.dependentCovered == 1 && (
        <>
          <EditableTable
            initialColumns={initialColumns}
            data={beforeCalibrationData}
            setData={setBeforeCalibrationData}
            srNo
            deletedRowIds={deletedRowIds}
            setDeletedRowIds={setDeletedRowIds}
            name="Dependent"
          />
          <br />
        </>
      )}

      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.create || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-add-outline"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={onSubmit}
          />
        )}
      </div>
      {downloadPdfloading && <LoaderModal loading={downloadPdfloading} />}
    </div>
  );
};

export default EditEmployeeMaster;
